'use strict';

import React, { Fragment, useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import RegistrationForm from 'Components/Forms/Models/User/RegistrationForm';
import LoginForm from 'Components/Forms/LoginForm';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import removeGetParameter from 'Functions/removeGetParameter';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
import { isTrue, getUrlParameter } from 'Shared/utilities';
const {
  app
} = window;
const REGISTERED_MSG = ['Bienvenue sur myWO ! Un email de confirmation ', 'd’inscription vous a été envoyé ainsi qu’un lien pour ', 'télécharger votre carte myWO. '].join('');
export default function QrCodeSubscription(props) {
  const [status, setStatus] = useState({
    info: isTrue(getUrlParameter('registered')) ? REGISTERED_MSG : undefined
  });
  const [user, setUser] = useState(app.state.session?.user);
  const [credentials, setLoginPwd] = useState(['', '']);
  const [state, setState] = useState(getUrlParameter('error') === 'login404' ? 'login' : isTrue(getUrlParameter('registered')) ? 'registered' : 'choice');
  const [redirect_loading, setRedirectLoading] = useState(false);
  useEffect(() => {
    if (state === 'choice' && app.state.session?.user?.roles?.length > 0) {
      displayWallet(app.state.session.user);
    } else if (isTrue(getUrlParameter('registered'))) {
      removeGetParameter('registered');
    }
  }, []);
  const redirect_loader = redirect_loading === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-blue']
  }) : undefined;
  const content = state === 'choice' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary']) + ' u-block u-margin-auto u-margin-bottom-20',
    onClick: e => setState('registration')
  }, "S'inscrire"), /*#__PURE__*/React.createElement("div", {
    className: "c-separator u-margin-bottom-0"
  }, "Ou"), /*#__PURE__*/React.createElement("p", null, "Vous avez d\xE9j\xE0 un compte myWO"), /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary']) + ' u-block u-margin-auto u-margin-bottom-20',
    onClick: e => setState('login')
  }, "Se connecter")) : state === 'login' ? /*#__PURE__*/React.createElement(LoginForm, {
    onLogin: user => displayWallet(user, 'login'),
    "with-credentials": true,
    credentials: credentials,
    source: 'Wallet-' + props.etablishment,
    "with-google": true,
    "with-linkedin": true
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-separator u-margin-bottom-25 u-margin-top-25"
  }), /*#__PURE__*/React.createElement("p", {
    className: "u-full-width u-text-center"
  }, "Pas de compte\xA0?"), /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['primary']) + ' u-block u-margin-auto u-margin-bottom-20',
    onClick: e => setState('registration')
  }, "Inscrivez-vous")) : state === 'not_allowed_user' ? /*#__PURE__*/React.createElement(Fragment, null, getFormStatus({
    error: 'Vous devez utiliser un compte client ou entreprise pour continuer.'
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: e => setState('choice'),
    className: bemit('c-arrow-btn', ['primary', 'big'])
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "c-arrow-btn__arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Retour \xE0 l'\xE9tape initiale"))) : state === 'registration' ? /*#__PURE__*/React.createElement(RegistrationForm, {
    onRegistration: handleRegistration,
    "include-etablishment-slug": true,
    "wallet-redirections": true,
    source: 'Wallet-' + props.etablishment,
    "with-google": true,
    "with-linkedin": true,
    requestLoginForm: handleRequestLoginForm
  }) : state === 'just_logged_in' && isTrue(user.wallet_enabled) ? /*#__PURE__*/React.createElement(Fragment, null, getFormStatus({
    statement: 'Bienvenue sur votre compte myWo !'
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    href: "/",
    className: bemit('c-flat-btn', ['front', 'blue', 'front-search'])
  }, "Accueil")) : state === 'just_logged_in' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['blue'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, "Bienvenue sur votre compte myWO\xA0!", /*#__PURE__*/React.createElement("br", null), "Toutes les informations et actualit\xE9s myWO sur votre mobile gr\xE2ce \xE0 notre carte d\xE9mat\xE9rialis\xE9e.")), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: bemit('c-flat-btn', ['front', 'blue', 'front-search']),
    onClick: requestRedirection
  }, "Je t\xE9l\xE9charge ma carte myWO", redirect_loader), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    href: "/",
    className: bemit('c-arrow-btn', ['primary', 'big']) + ' u-margin-top-40'
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "c-arrow-btn__arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Retour \xE0 l'accueil"))) : state === 'connected' && isTrue(user.wallet_enabled) ? /*#__PURE__*/React.createElement(Fragment, null, getFormStatus({
    statement: 'Votre compte a déjà été créé avec succès.'
  }), /*#__PURE__*/React.createElement(Button, {
    href: "/",
    className: bemit('c-flat-btn', ['front', 'blue', 'front-search'])
  }, "Retour \xE0 l'accueil", redirect_loader)) : state === 'connected' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['blue'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, "Votre compte a d\xE9j\xE0 \xE9t\xE9 cr\xE9\xE9 avec succ\xE8s.", /*#__PURE__*/React.createElement("br", null), "Toutes les informations et actualit\xE9s myWO sur votre mobile gr\xE2ce \xE0 notre carte d\xE9mat\xE9rialis\xE9e.")), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: bemit('c-flat-btn', ['front', 'blue', 'front-search']),
    onClick: requestRedirection
  }, "Je t\xE9l\xE9charge ma carte myWO", redirect_loader), getFormStatus(status), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    href: "/",
    className: bemit('c-arrow-btn', ['primary', 'big']) + ' u-margin-top-40'
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "c-arrow-btn__arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Revenir \xE0 l'accueil de myWO"))) : state === 'registered' ? /*#__PURE__*/React.createElement(Fragment, null, getFormStatus(status)) : state === 'emailed' ? /*#__PURE__*/React.createElement(Fragment, null, getFormStatus({
    info: 'Un email vous a été envoyé pour créer votre carte myWO.'
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    href: "/",
    className: bemit('c-arrow-btn', ['primary', 'big']) + ' u-margin-top-40'
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "c-arrow-btn__arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Revenir \xE0 l'accueil de myWO"))) : undefined;
  const output = /*#__PURE__*/React.createElement("div", {
    className: "qr-code-subscription"
  }, content);
  return output;
  function handleRegistration(response) {
    const {
      info,
      ...session
    } = response;
    app.state.session = session;
    app.state.session.fetched = true;
    displayWallet(response.user, 'registration');
  }
  function displayWallet(user, source) {
    if (user.roles.includes('customer') === false && user.roles.includes('company') === false) {
      return setState('not_allowed_user');
    }
    setUser(user);
    if (source === 'login') {
      return setState('just_logged_in');
    } else if (source === 'registration') {
      setStatus({
        info: REGISTERED_MSG
      });
      return setState('registered');
    } else {
      setStatus({});
      return setState('connected');
    }
  }
  async function requestRedirection() {
    if (redirect_loading === true) return;
    setRedirectLoading(true);
    try {
      var response = await ajaxRequest(action('GetCaptainWalletUrl'), {
        data: {
          slug: window.location.pathname.split('/')[2]
        }
      });
    } catch (e) {
      console.error(e);
      setRedirectLoading(false);
      return setStatus(e);
    }
    setRedirectLoading(false);
    return window.open(response.url);
  }
  function handleRequestLoginForm({
    login = '',
    password = ''
  }) {
    setLoginPwd([login, password]);
    setState('login');
  }
}
